import { FC } from 'react';

interface ChatBubbleProps {
  onClick: () => void;
  hasNotification?: boolean;
  notificationCount?: number;
}

const ChatBubble: FC<ChatBubbleProps> = ({ onClick, hasNotification = false, notificationCount = 0 }) => {
  return (
    <button
      onClick={onClick}
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-vine hover:bg-vineHover shadow-lg flex items-center justify-center transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-orange focus:ring-offset-2"
      aria-label="Open chat assistant"
    >
      {/* Chat icon */}
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="text-white"
      >
        <path
          d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7118 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0035 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92179 4.44061 8.37488 5.27072 7.03258C6.10083 5.69028 7.28825 4.6056 8.7 3.90003C9.87812 3.30496 11.1801 2.99659 12.5 3.00003H13C15.0843 3.11502 17.053 3.99479 18.5291 5.47089C20.0052 6.94699 20.885 8.91568 21 11V11.5Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      {/* Notification badge */}
      {hasNotification && (
        <span className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1.5 bg-orange rounded-full flex items-center justify-center text-xs font-medium text-white">
          {notificationCount > 0 ? (notificationCount > 9 ? '9+' : notificationCount) : ''}
        </span>
      )}
    </button>
  );
};

export default ChatBubble;
